import { defineComponent } from 'vue';
import CategoryOneFileUploadComponent from '@/components/CategoryOne/CategoryOneFileUploadComponent.vue';
export default defineComponent({
    name: 'CategoryOneFileUploadDialog',
    props: {
        propSelected: Array
    },
    components: { CategoryOneFileUploadComponent },
    data: function () {
        return {
            show: false
        };
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        showHideDialog() {
            this.show = !this.show;
        },
        createNew() {
            this.show = true;
        }
    }
});
